import React from 'react'
import { Input } from './styles'

const InputField = props => (
    <Input
      {...props}
    />
  )

export default InputField
